import React from "react";
import "./SuperChatUser.scss";

export const SuperChatUser = ({ message, userName }) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  // Use userName prop if provided, otherwise fall back to message.name or "You"
  const displayName = userName || message.name || "You";

  return (
    <div className="super-agent-bubble user-right">
      <div className="super-agent-bubble-meta">
        <span className="super-agent-user-name">{displayName}</span>
        <span className="super-agent-time">{`${day} ${time}`}</span>
      </div>
      <div className="super-agent-bubble-inner">{message.text}</div>
    </div>
  );
};
